module.exports = __webpack_public_path__ + "img/BOSdynamics9.46cadb93.jpg";